import { validate as validateEmail } from 'email-validator';

const capitalizeFirstLetter = (str: string): string => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export { capitalizeFirstLetter, validateEmail };
